import { render, staticRenderFns } from "./PropagateSectionModal.vue?vue&type=template&id=78145326&scoped=true&"
import script from "./PropagateSectionModal.vue?vue&type=script&lang=js&"
export * from "./PropagateSectionModal.vue?vue&type=script&lang=js&"
import style0 from "./PropagateSectionModal.vue?vue&type=style&index=0&id=78145326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78145326",
  null
  
)

export default component.exports